module.exports = __webpack_public_path__ + "static/about-image-5_m-51e5e6c2efc5259857097e1a68c89ec0.jpg";